export const CHART_FORM_STEPS = ['daily', 'weekly', 'monthly'];
export const CHART_FORM_TYPES = ['Simple'];
export const CHART_FORM_POINTS = [10000];
